import __request__ from "routing/request";
export function systemStats(requestOptions) {
  return __request__("GET", "/system/stats", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function fsStats(requestOptions) {
  return __request__("GET", "/system/stats/fs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function jvmStats(requestOptions) {
  return __request__("GET", "/system/stats/jvm", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function networkStats(requestOptions) {
  return __request__("GET", "/system/stats/network", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function osStats(requestOptions) {
  return __request__("GET", "/system/stats/os", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function processStats(requestOptions) {
  return __request__("GET", "/system/stats/process", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
